module.exports = __webpack_public_path__ + "static/media/www.escapejkl.fi.ad710f13.jpg";